module.exports = __webpack_public_path__ + "static/media/king_club.6efbe88e.png";